export default "__VITE_ASSET__B5QAtINc__ 480w, __VITE_ASSET__CO8PsMtz__ 800w, __VITE_ASSET__DBHNv5ra__ 1200w, __VITE_ASSET__BaT4iH5O__ 1456w";